// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as $$String from "../../../../../../../node_modules/rescript/lib/es6/string.js";
import * as FraudType from "../types/FraudType.bs.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as BlacklistType from "../types/BlacklistType.bs.js";
import * as TrustAndSafetyAssetsManager from "../../assets/TrustAndSafetyAssetsManager.bs.js";

var banIcon = TrustAndSafetyAssetsManager.getImage("ban-icon.svg");

var warningIcon = TrustAndSafetyAssetsManager.getImage("warning-icon.svg");

var spinnerIcon = TrustAndSafetyAssetsManager.getImage("spinner-icon.svg");

var checkIcon = TrustAndSafetyAssetsManager.getImage("check-icon.svg");

function BlacklistPartnerForm(Props) {
  var partnerId = Props.partnerId;
  var fraudType = Props.fraudType;
  var blacklistTypes = Props.blacklistTypes;
  var comment = Props.comment;
  var onPartnerIdChange = Props.onPartnerIdChange;
  var onFraudTypeChange = Props.onFraudTypeChange;
  var onBlacklistTypeToggle = Props.onBlacklistTypeToggle;
  var onCommentChange = Props.onCommentChange;
  var onSubmit = Props.onSubmit;
  var isSubmitting = Props.isSubmitting;
  var validationErrors = Props.validationErrors;
  var isFormValid = List.length(validationErrors) === 0;
  var getMissingFieldsMessage = function (param) {
    if (List.length(validationErrors) <= 0) {
      return null;
    }
    var missingFields = $$String.concat(", ", validationErrors);
    return React.createElement("div", {
                className: "c-blacklist-partner-page__status-message"
              }, React.createElement("img", {
                    alt: "",
                    src: warningIcon
                  }), React.createElement("span", undefined, "Required: " + missingFields));
  };
  return React.createElement("div", {
              className: "c-blacklist-partner-page__form-container"
            }, React.createElement("div", {
                  className: "c-blacklist-partner-page__form-header"
                }, React.createElement("div", {
                      className: "c-blacklist-partner-page__form-title"
                    }, React.createElement("img", {
                          alt: "",
                          src: banIcon
                        }), React.createElement("span", undefined, "Partner Blacklist"))), React.createElement("div", {
                  className: "c-blacklist-partner-page__form-description"
                }, "Blacklist a partner with specified fraud type. All actions are logged for audit."), React.createElement("form", {
                  className: "c-blacklist-partner-page__form",
                  onSubmit: onSubmit
                }, React.createElement("div", {
                      className: "c-blacklist-partner-page__form-section"
                    }, React.createElement("div", {
                          className: "c-blacklist-partner-page__form-section-header"
                        }, React.createElement("span", {
                              className: "c-blacklist-partner-page__form-section-title"
                            }, "Blacklist Details")), React.createElement("div", {
                          className: "c-blacklist-partner-page__form-fields"
                        }, React.createElement("div", {
                              className: "c-blacklist-partner-page__form-field"
                            }, React.createElement("label", {
                                  className: "c-blacklist-partner-page__form-label"
                                }, "Partner ID *"), React.createElement("input", {
                                  className: "c-blacklist-partner-page__form-input",
                                  placeholder: "Enter partner ID",
                                  required: true,
                                  type: "text",
                                  value: partnerId,
                                  onChange: (function ($$event) {
                                      return Curry._1(onPartnerIdChange, $$event.target.value);
                                    })
                                })), React.createElement("div", {
                              className: "c-blacklist-partner-page__form-field"
                            }, React.createElement("label", {
                                  className: "c-blacklist-partner-page__form-label"
                                }, "Fraud Type *"), React.createElement("select", {
                                  className: "c-blacklist-partner-page__form-input",
                                  required: true,
                                  value: Belt_Option.mapWithDefault(fraudType, "", FraudType.toString),
                                  onChange: (function ($$event) {
                                      var value = $$event.target.value;
                                      var ft = FraudType.fromString(value);
                                      if (ft !== undefined) {
                                        return Curry._1(onFraudTypeChange, ft);
                                      }
                                      
                                    })
                                }, React.createElement("option", {
                                      disabled: true,
                                      value: ""
                                    }, "Select fraud type..."), Belt_Array.map(FraudType.allFraudTypes, (function (ft) {
                                        return React.createElement("option", {
                                                    key: FraudType.toString(ft),
                                                    title: FraudType.toDescription(ft),
                                                    value: FraudType.toString(ft)
                                                  }, FraudType.toDisplayString(ft));
                                      })))), React.createElement("div", {
                              className: "c-blacklist-partner-page__form-field"
                            }, React.createElement("label", {
                                  className: "c-blacklist-partner-page__form-label"
                                }, "Blacklist Type *"), React.createElement("div", {
                                  className: "c-blacklist-partner-page__checkbox-group"
                                }, Belt_Array.map(BlacklistType.allBlacklistTypes, (function (bt) {
                                        var isSupported = BlacklistType.isSupported(bt);
                                        var isChecked = Belt_Array.some(blacklistTypes, (function (t) {
                                                return t === bt;
                                              }));
                                        return React.createElement("label", {
                                                    key: BlacklistType.toString(bt),
                                                    className: "c-blacklist-partner-page__checkbox-item" + (
                                                      isSupported ? "" : " c-blacklist-partner-page__checkbox-item--disabled"
                                                    )
                                                  }, React.createElement("input", {
                                                        checked: isChecked,
                                                        disabled: !isSupported,
                                                        type: "checkbox",
                                                        onChange: (function (param) {
                                                            if (isSupported) {
                                                              return Curry._1(onBlacklistTypeToggle, bt);
                                                            }
                                                            
                                                          })
                                                      }), React.createElement("span", undefined, BlacklistType.toDisplayString(bt), isSupported ? null : React.createElement("span", {
                                                              className: "c-blacklist-partner-page__coming-soon"
                                                            }, " (Coming Soon)")));
                                      })))), React.createElement("div", {
                              className: "c-blacklist-partner-page__form-field"
                            }, React.createElement("label", {
                                  className: "c-blacklist-partner-page__form-label"
                                }, "Comment (Optional)"), React.createElement("textarea", {
                                  className: "c-blacklist-partner-page__form-textarea",
                                  placeholder: "Provide context for this blacklist action (e.g., ticket reference, investigation details)...",
                                  rows: 4,
                                  value: comment,
                                  onChange: (function ($$event) {
                                      return Curry._1(onCommentChange, $$event.target.value);
                                    })
                                }), React.createElement("div", {
                                  className: "c-blacklist-partner-page__form-hint"
                                }, "This will be visible in partner records and audit logs")))), React.createElement("div", {
                      className: "c-blacklist-partner-page__form-footer"
                    }, getMissingFieldsMessage(undefined), React.createElement("button", {
                          className: "c-blacklist-partner-page__submit-button",
                          disabled: isSubmitting || !isFormValid,
                          type: "submit"
                        }, isSubmitting ? React.createElement(React.Fragment, undefined, React.createElement("img", {
                                    alt: "",
                                    src: spinnerIcon
                                  }), "Blacklisting...") : React.createElement(React.Fragment, undefined, React.createElement("img", {
                                    alt: "",
                                    src: checkIcon
                                  }), "Blacklist Partner")))));
}

var make = BlacklistPartnerForm;

export {
  banIcon ,
  warningIcon ,
  spinnerIcon ,
  checkIcon ,
  make ,
  
}
/* banIcon Not a pure module */
